/* global axios */
import ApiClient from './ApiClient';

class CalendarAPI extends ApiClient {
  constructor() {
    super('calendar', { accountScoped: true });
  }

  getEvents(params) {
    return axios.get(`${this.url}/events`, { params });
  }

  getEventDetails(eventId) {
    return axios.get(`${this.url}/event_details/${eventId}`);
  }

  createEvent(eventData) {
    // A rota REST é POST /calendar (o `post :create` do collection mapeia pro
    // root do recurso, não pra /calendar/create) — mandar /create dava 404.
    return axios.post(this.url, eventData);
  }

  updateEvent(eventId, eventData) {
    return axios.put(`${this.url}/${eventId}`, eventData);
  }

  deleteEvent(eventId) {
    return axios.delete(`${this.url}/${eventId}`);
  }
}

export default new CalendarAPI();
